import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'input'
})
export class InputDirective implements OnInit {

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.el.nativeElement.setAttribute('autocomplete', 'off');
  }

}
